
import Vue from 'vue';
import VueRouter from 'vue-router';
// import Gate from "./Gate";
// Vue.prototype.$gate = new Gate(window.user);

Vue.use(VueRouter);
window.Vue = require('vue');



// Dashbord
import Settings from './components/Settings.vue'

// Greyman Route Declarations
import GreymanDash from './components/views/greyman/GreymanHome.vue'
import GreymanPassport from './components/views/greyman/GreymanPassport.vue'
import GreymanModifyACL from './components/views/greyman/GreymanACL.vue'
import GreymanSettings from './components/views/greyman/GreymanSettings.vue'
// Admin Route Declarations
import AdminDash from './components/views/admin/AdminHome.vue'
import AdminAddDiscount from './components/views/admin/AdminAddDiscount.vue'
import AdminAddColor from './components/views/admin/AdminAddColor.vue'
import AdminAddGrade from './components/views/admin/AdminAddGrade.vue'
import AdminAddQuality from './components/views/admin/AdminAddQuality.vue'
import AdminManageWarehouse from './components/views/admin/AdminManageWarehouse.vue'
import AdminCalendar from './components/views/admin/AdminCalendar.vue'
import AdminGSTProfiles from './components/views/admin/AdminGSTProfiles.vue'
import AdminModifyUserType from './components/views/admin/AdminModifyUserType.vue'
import AdminSupportTicket from './components/views/admin/AdminSupportTicket.vue'
import AdminTermsOfService from './components/views/admin/AdminTermsOfService.vue'
import AdminSettings from './components/views/admin/AdminSettings.vue'
// Buyer Route Declarations
import BuyerDash from './components/views/buyer/BuyerHome.vue'
import BuyerAddresses from './components/views/buyer/BuyerAddresses.vue'
import BuyerCalendar from './components/views/buyer/BuyerCalendar.vue'
import BuyerUpcomingAuctions from './components/views/buyer/BuyerUpcomingAuctions.vue'
import BuyerCurrentAuctions from './components/views/buyer/BuyerCurrentAuctions.vue'
import BuyerPastAuctions from './components/views/buyer/BuyerPastAuctions.vue'
import BuyerLots from './components/views/buyer/BuyerLots.vue'
import BuyerLotTicket from './components/views/buyer/BuyerLotTicket.vue'
import BuyerAcquiredLots from './components/views/buyer/BuyerAcquiredLots.vue'
import BuyerWishlist from './components/views/buyer/BuyerWishlist.vue'
import BuyerWishlistLots from './components/views/buyer/BuyerWishlistLots.vue'
import BuyerAutobids from './components/views/buyer/BuyerAutobids.vue'
import BuyerAutobidLots from './components/views/buyer/BuyerAutobidLots.vue'
import BuyerLotDetails from './components/views/buyer/BuyerLotDetails.vue'
import BuyerAuctionedLots from './components/views/buyer/BuyerAuctionedLots.vue'
import BuyerUpcomingLots from './components/views/buyer/BuyerUpcomingLots.vue'
import BuyerLotBidding from './components/views/buyer/BuyerLotBidding.vue'
import BuyerBidStatus from './components/views/buyer/BuyerBidStatus.vue'
import BuyerGSTProfile from './components/views/buyer/BuyerGSTProfile.vue'
import BuyerSupportTicket from './components/views/buyer/BuyerSupportTicket.vue'
import BuyerLiveBidding from './components/views/buyer/BuyerLiveBidding.vue'
import BuyerSettings from './components/views/buyer/BuyerSettings.vue'
// Auction Manager Route Declarations
import AuctionManagerDash from './components/views/auction-manager/AuctionManagerHome.vue'
import AuctionManagerAddSeller from './components/views/auction-manager/AuctionManagerAddSeller.vue'
import AuctionManagerSellerList from './components/views/auction-manager/AuctionManagerSellerList.vue'
import AuctionManagerBuyerList from './components/views/auction-manager/AuctionManagerBuyerList.vue'
import AuctionManagerUserAccess from './components/views/auction-manager/AuctionManagerUserAccess.vue'
import AuctionManagerCreateAuction from './components/views/auction-manager/AuctionManagerCreateAuction.vue'
import AuctionManagerAddLots from './components/views/auction-manager/AuctionManagerAddLots.vue'
import AuctionManagerAuctionLots from './components/views/auction-manager/AuctionManagerAuctionLots.vue'
import AuctionManagerOldDataEntry from './components/views/auction-manager/AuctionManagerOldDataEntry.vue'
import AuctionManagerAuctionStatus from './components/views/auction-manager/AuctionManagerAuctionStatus.vue'
import AuctionManagerAddNewLot from './components/views/auction-manager/AuctionManagerAddNewLot.vue'
import AuctionManagerLotDetails from './components/views/auction-manager/AuctionManagerLotDetails.vue'
import AuctionManagerSoldLots from './components/views/auction-manager/AuctionManagerSoldLots.vue'
import AuctionManagerAvailableLots from './components/views/auction-manager/AuctionManagerAvailableLots.vue'
import AuctionManagerCurrentAuctions from './components/views/auction-manager/AuctionManagerCurrentAuctions.vue'
import AuctionManagerUpcomingAuctions from './components/views/auction-manager/AuctionManagerUpcomingAuctions.vue'
import AuctionManagerPastAuctions from './components/views/auction-manager/AuctionManagerPastAuctions.vue'
import AuctionManagerPulledLots from './components/views/auction-manager/AuctionManagerPulledLots.vue'
import AuctionManagerCalendar from './components/views/auction-manager/AuctionManagerCalendar.vue'
import AuctionManagerLotBidHistory from './components/views/auction-manager/AuctionManagerLotBidHistory'
import AuctionManagerAuctionReport from './components/views/auction-manager/AuctionManagerAuctionReport.vue'
import AuctionManagerSupportTicket from './components/views/auction-manager/AuctionManagerSupportTicket.vue'
import AuctionManagerSettings from './components/views/auction-manager/AuctionManagerSettings.vue'
// Seller Route Declarations
import SellerDash from './components/views/seller/SellerHome.vue'
// import SellerAddNewLot from './components/views/seller/SellerAddNewLot.vue'
import SellerLots from './components/views/seller/SellerLots.vue'
import SellerLotsList from './components/views/seller/SellerLotsList.vue'
import SellerSoldLots from './components/views/seller/SellerSoldLots.vue'
import SellerSoldLotsList from './components/views/seller/SellerSoldLotsList.vue'
import SellerLotDetails from './components/views/seller/SellerLotDetails.vue'
import SellerAuctionList from './components/views/seller/SellerAuctionList.vue'
import SellerGSTProfile from './components/views/seller/SellerGSTProfile.vue'
import SellerAddresses from './components/views/seller/SellerAddresses.vue'
import SellerCalendar from './components/views/seller/SellerCalendar.vue'
import SellerCurrentAuctions from './components/views/seller/SellerCurrentAuctions'
import SellerAuctionLots from './components/views/seller/SellerAuctionLots.vue'
import SellerAuctionReport from './components/views/seller/SellerAuctionReport.vue'
import SellerSupportTicket from './components/views/seller/SellerSupportTicket.vue'
import SellerSettings from './components/views/seller/SellerSettings.vue'
// Misc. Routes
import ExampleComponent from './components/ExampleComponent.vue'
import NotFound from './components/404.vue'
import AccessDenied from './components/AccessDenied.vue'
import PaymentImage from './components/Payment.vue'
import NoData from './components/NoData.vue'



Vue.component('passport-clients',require('./components/passport/Clients.vue').default);
Vue.component('passport-authorized-clients',require('./components/passport/AuthorizedClients.vue').default);
Vue.component('passport-personal-access-tokens',require('./components/passport/PersonalAccessTokens.vue').default);

Vue.component('not-found',require('./components/404.vue').default);
Vue.component('access-denied',require('./components/AccessDenied.vue').default);
// Vue.component('notification-bar',require('./components/NotificationBar.vue').default);

const routes = [
        {
          path: '/home/greyman',
          component: GreymanDash
        },
        {
          path: '/home/admin',
          component: AdminDash
        },
        {
          path: '/home/auction-manager',
          component: AuctionManagerDash
        },
        {
          path: '/home/buyer',
          component: BuyerDash
        },
        {
          path: '/home/seller',
          component: SellerDash
        },
        // Greyman Routes
        {
          path: '/home/greyman/dashboard',
          meta:{ title: 'Greyman Change User Type'},
          component: GreymanDash,
          name: 'Greyman | Dashboard'
        },
        {
          path: '/home/greyman/modify-user-type',
          meta:{ title: 'Admin Modify User Types'},
          component: GreymanModifyACL,
          name: 'Greyman | Modify User Type'
        },
        {
          path: '/home/greyman/passport',
          meta:{ title: 'Greyman Passport'},
          component: GreymanPassport,
          name: 'Greyman | Passport'
        },
        {
          path: '/home/greyman/settings',
          meta:{ title: 'Greyman Settings'},
          component: GreymanSettings,
          name: 'Greyman | Settings'
        },
        // Admin Routes
        {
          path: '/home/admin/dashboard',
          meta:{ title: 'Admin | Dashboard'},
          component: AdminDash,
          name: 'Admin | Dashboard'
        },
        {
          path: '/home/admin/add-color',
          meta:{ title: 'Admin | Color List'},
          component: AdminAddColor,
          name: 'Admin | Color List'
        },
        {
          path: '/home/admin/add-discount',
          meta:{ title: 'Admin | Discount List'},
          component: AdminAddDiscount,
          name: 'Admin | Discount List'
        },
        {
          path: '/home/admin/add-grade',
          meta:{ title: 'Admin | Grade List'},
          component: AdminAddGrade,
          name: 'Admin | Grade List'
        },
        {
          path: '/home/admin/add-quality',
          meta:{ title: 'Admin | Quality List'},
          component: AdminAddQuality,
          name: 'Admin | Quality List'
        },
        {
          path: '/home/admin/modify-user-type',
          meta:{ title: 'Admin | Modify User Types'},
          component: AdminModifyUserType,
          name: 'Admin | Modify User Type'
        },
        {
          path: '/home/admin/gst-profiles',
          meta:{ title: 'Admin | Manage GST Profiles'},
          component: AdminGSTProfiles,
          name: 'Admin | Manage GST Profiles'
        },
        {
          path: '/home/admin/manage-warehouse',
          meta:{ title: 'Admin | Manage Warehouse'},
          component: AdminManageWarehouse,
          name: 'Admin | Manage Warehouse'
        },
        {
          path: '/home/admin/support-ticket',
          meta:{ title: 'Admin | Support Ticket'},
          component: AdminSupportTicket,
          name: 'Admin | Support Ticket'
        },
        {
          path: '/home/admin/add-terms',
          meta:{ title: 'Admin | Add Terms Of Service'},
          component: AdminTermsOfService,
          name: 'Admin | Add Terms Of Service'
        },
        {
          path: '/home/admin/settings',
          meta:{ title: 'Admin | Settings'},
          component: AdminSettings,
          name: 'Admin | Settings'
        },
        // Auction Manager Routes
        {
          path: '/home/auction-manager/dashboard',
          meta:{ title: 'Auction Manager | Dashboard'},
          component: AuctionManagerDash,
          name: 'Auction Manager | Dashboard'
        },
        {
          path: '/home/auction-manager/add-new-seller',
          meta:{ title: 'Auction Manager | Add New Seller'},
          component: AuctionManagerAddSeller,
          name: 'Auction Manager | Add New Seller'
        },
        {
          path: '/home/auction-manager/seller-list',
          meta:{ title: 'Auction Manager | Seller List'},
          component: AuctionManagerSellerList,
          name: 'Auction Manager | Seller List'
        },
        {
          path: '/home/auction-manager/buyer-list',
          meta:{ title: 'Auction Manager | Buyer List'},
          component: AuctionManagerBuyerList,
          name: 'Auction Manager | Buyer List'
        },
        {
          path: '/home/auction-manager/manage-user-access',
          meta:{ title: 'Auction Manager | Manage User Access'},
          component: AuctionManagerUserAccess,
          name: 'Auction Manager | Manage User Access'
        },
        {
          path: '/home/auction-manager/create-auction',
          meta:{ title: 'Auction Manager | Create Auction'},
          component: AuctionManagerCreateAuction,
          name: 'Auction Manager | Create Auction'
        },
        {
          path: '/home/auction-manager/add-lots',
          meta:{ title: 'Auction Manager | Add Lot to Auction'},
          component: AuctionManagerAddLots,
          name: 'Auction Manager | Add Lot to Auction'
        },
        {
          path: '/home/auction-manager/auction-lots/:id',
          meta:{ title: 'Auction Manager | Auctioned Lots'},
          component: AuctionManagerAuctionLots,
          name: 'Auction Manager | Auctioned Lots'
        },
        {
          path: '/home/auction-manager/past-auctions',
          meta:{ title: 'Action Manager | Past Auctions'},
          component: AuctionManagerPastAuctions,
          name: 'Auction Manager | Past Auctions'
        },
        {
          path: '/home/auction-manager/current-auctions',
          meta:{ title: 'Action Manager | Current Auctions'},
          component: AuctionManagerCurrentAuctions,
          name: 'Auction Manager | Current Auctions'
        },
        {
          path: '/home/auction-manager/upcoming-auctions',
          meta:{ title: 'Action Manager | Upcoming Auctions'},
          component: AuctionManagerUpcomingAuctions,
          name: 'Auction Manager | Upcoming Auctions'
        },
        {
          path: '/home/auction-manager/auction-status',
          meta:{ title: 'Auction Manager | Auction Status'},
          component: AuctionManagerAuctionStatus,
          name: 'Auction Manager | Auction Status'
        },
        {
          path: '/home/auction-manager/add-new-lot',
          meta:{ title: 'Auction Manager | Add New Lot'},
          component: AuctionManagerAddNewLot,
          name: 'Auction Manager | Add New Lot'
        },
        {
          path: '/home/auction-manager/available-lots',
          meta:{ title: 'Auction Manager | Available Lots'},
          component: AuctionManagerAvailableLots,
          name: 'Auction Manager | Available Lots'
        },
        {
          path: '/home/auction-manager/sold-lots',
          meta:{ title: 'Auction Manager | Sold Lots'},
          component: AuctionManagerSoldLots,
          name: 'Auction Manager | Sold Lots'
        },
        {
          path: '/home/auction-manager/pulled-lots',
          meta:{ title: 'Auction Manager | Pulled Lots'},
          component: AuctionManagerPulledLots,
          name: 'Auction Manager | Pulled Lots'
        },
        {
          path: '/home/auction-manager/lot-details/:id',
          meta:{ title: 'Auction Manager | Lot Details'},
          component: AuctionManagerLotDetails,
          name: 'Auction Manager | Lot Details'
        },
        {
          path: '/home/auction-manager/old-data-entry',
          meta:{ title: 'Auction Manager | Past Record Entry Module'},
          component: AuctionManagerOldDataEntry,
          name: 'Auction Manager | Past Record Entry Module'
        },
        {
          path: '/home/auction-manager/calendar',
          meta:{ title: 'Auction Manager | Calendar'},
          component: AuctionManagerCalendar,
          name: 'Auction Manager | Calendar'
        },
        {
          path: '/home/auction-manager/auction-report/:id',
          meta:{ title: 'Auction Manager | Auction Report'},
          component: AuctionManagerAuctionReport,
          name: 'Auction Manager | AuctionReport'
        },
        {
          path: '/home/auction-manager/bid-history/:id/:lot_id',
          meta:{ title: 'Auction Manager | Auction Report | Lot - Bid History'},
          component: AuctionManagerLotBidHistory,
          name: 'Auction Manager | Auction Report | Lot Bid History'
        },
        {
          path: '/home/auction-manager/support-ticket',
          meta:{ title: 'Auction Manager Support Ticket'},
          component: AuctionManagerSupportTicket,
          name: 'Auction Manager | Support Ticket'
        },
        {
          path: '/home/auction-manager/settings',
          meta:{ title: 'Auction Manager Settings'},
          component: AuctionManagerSettings,
          name: 'Auction Manager | Settings'
        },
        // Buyer Routes
        {
          path: '/home/buyer/dashboard',
          meta:{ title: 'Buyer Home'},
          component: BuyerDash,
          name: 'Buyer | Home'
        },
        {
          path: '/home/buyer/addresses',
          meta:{ title: 'Buyer Address'},
          component: BuyerAddresses,
          name: 'Buyer | Addresses'
        },
        {
          path: '/home/buyer/calendar',
          meta:{ title: 'Buyer Calendar'},
          component: BuyerCalendar,
          name: 'Buyer | Calendar'
        },
        {
          path: '/home/buyer/upcoming-auctions',
          meta:{ title: 'Buyer Upcoming Auctions'},
          component: BuyerUpcomingAuctions,
          name: 'Buyer | Upcoming Auctions'
        },
        {
          path: '/home/buyer/lot-ticket/:id',
          meta:{ title: 'Buyer | Lot Ticket'},
          component: BuyerLotTicket,
          name: 'Buyer | Lot Ticket'
        },
        {
          path: '/home/buyer/current-auctions',
          meta:{ title: 'Buyer Current Auctions'},
          component: BuyerCurrentAuctions,
          name: 'Buyer | Current Auctions'
        },
        {
          path: '/home/buyer/past-auctions',
          meta:{ title: 'Buyer Past Auctions'},
          component: BuyerPastAuctions,
          name: 'Buyer | Past Auctions'
        },
        {
          path: '/home/buyer/acquired-lots',
          meta:{ title: 'Buyer Acquired Lots'},
          component: BuyerAcquiredLots,
          name: 'Buyer | Acquired Lots'
        },
        {
          path: '/home/buyer/wishlist',
          meta:{ title: 'Buyer Wishlist'},
          component: BuyerWishlist,
          name: 'Buyer | Wishlist'
        },
        {
          path: '/home/buyer/wishlist-lots/:id',
          meta:{ title: 'Buyer Wished Lots'},
          component: BuyerWishlistLots,
          name: 'Buyer | Wished Lots'
        },
        {
          path: '/home/buyer/autobids',
          meta:{ title: 'Buyer Autobids'},
          component: BuyerAutobids,
          name: 'Buyer | Autobids'
        },
        {
          path: '/home/buyer/autobid-lots/:id',
          meta:{ title: 'Buyer Auto-Bid Lots'},
          component: BuyerAutobidLots,
          name: 'Buyer | Auto-Bid Lots'
        },
        {
          path: '/home/buyer/lots/:id',
          meta:{ title: 'Auction Lots'},
          component: BuyerLots,
          name: 'Buyer | Available Lots'
        },
        {
          path: '/home/buyer/lot-details/:id',
          meta:{ title: 'Buyer Lot Details'},
          component: BuyerLotDetails,
          name: 'Buyer | Lot Details'
        },
        {
          path: '/home/buyer/auctioned-lots',
          meta:{ title: 'Buyer Auctioned Lots'},
          component: BuyerAuctionedLots,
          name: 'Buyer | Auctioned Lots'
        },
        {
          path: '/home/buyer/upcoming-lots',
          meta:{ title: 'Buyer Upcoming Lots'},
          component: BuyerUpcomingLots,
          name: 'Buyer | Upcoming Lots'
        },
        {
          path: '/home/buyer/lot-bidding/:id',
          meta:{ title: 'Buyer Lot Bidding'},
          component: BuyerLotBidding,
          name: 'Buyer | Lot Bidding'
        },
        {
          path: '/home/buyer/bid-status',
          meta:{ title: 'Buyer Bid Status'},
          component: BuyerBidStatus,
          name: 'Buyer | Bid Status'
        },
        {
          path: '/home/buyer/gst-profile',
          meta:{ title: 'Buyer GST Profile'},
          component: BuyerGSTProfile,
          name: 'Buyer | GST Profile'
        },
        {
          path: '/home/buyer/support-ticket',
          meta:{ title: 'Buyer Support Ticket'},
          component: BuyerSupportTicket,
          name: 'Buyer | Support Ticket'
        },
        {
          path: '/home/buyer/live-bidding/:id',
          meta:{ title: 'Buyer Live Bidding'},
          component: BuyerLiveBidding,
          name: 'Buyer | Live Bidding'
        },
        {
          path: '/home/buyer/settings',
          meta:{ title: 'Buyer Settings'},
          component: BuyerSettings,
          name: 'Buyer | Settings'
        },
        // Seller Routes
        {
          path: '/home/seller/dashboard',
          meta:{ title: 'Seller | Dashboard'},
          component: SellerDash,
          name: 'Seller | Dashboard'
        },
        // {
        //   path: '/home/seller/new-lot',
        //   meta:{ title: 'Seller | Add New Lot'},
        //   component: SellerAddNewLot,
        //   name: 'Seller | Add New Lot'
        // },
        {
          path: '/home/seller/lots',
          meta:{ title: 'Seller | Lots'},
          component: SellerLots,
          name: 'Seller | My Lots'
        },
        {
          path: '/home/seller/lots-list/:id',
          meta:{ title: 'Seller | Lots List'},
          component: SellerLotsList,
          name: 'Seller | My Lots - List'
        },
        {
          path: '/home/seller/sold-lots',
          meta:{ title: 'Seller | Sold Lots'},
          component: SellerSoldLots,
          name: 'Seller | Sold Lots'
        },
        {
          path: '/home/seller/sold-lots-list/:id',
          meta:{ title: 'Seller | Sold Lots List'},
          component: SellerSoldLotsList,
          name: 'Seller | Sold Lots - List'
        },
        {
          path: '/home/seller/lot-details/:id',
          meta:{ title: 'Seller | Lot Details'},
          component: SellerLotDetails,
          name: 'Seller | Lot Details'
        },
        // {
        //   path: '/home/seller/auction-list',
        //   meta:{ title: 'Seller | Auction List'},
        //   component: SellerAuctionList,
        //   name: 'Seller | Auction List'
        // },
        {
          path: '/home/seller/current-auctions',
          meta:{ title: 'Seller Current Auctions'},
          component: SellerCurrentAuctions,
          name: 'Seller | Current Auctions'
        },
        {
          path: '/home/seller/auction-lots/:id',
          meta:{ title: 'Seller - Current Auction Lots'},
          component: SellerAuctionLots,
          name: 'Seller | Currently Auctioned Lots'
        },
        {
          path: '/home/seller/calendar',
          meta:{ title: 'Seller | Calendar'},
          component: SellerCalendar,
          name: 'Seller | Calendar'
        },
        {
          path: '/home/seller/auction-list',
          meta:{ title: 'Seller | Auction List'},
          component: SellerAuctionList,
          name: 'Seller | Auction List'
        },
        {
          path: '/home/seller/auction-report/:id',
          meta:{ title: 'Seller | Auction Report'},
          component: SellerAuctionReport,
          name: 'Seller | Auction Report'
        },
        {
          path: '/home/seller/gst-profile',
          meta:{ title: 'Seller | GST Profile'},
          component: SellerGSTProfile,
          name: 'Seller | GST Profile'
        },
        {
          path: '/home/seller/addresses',
          meta:{ title: 'Seller | Address'},
          component: SellerAddresses,
          name: 'Seller | Addresses'
        },
        {
          path: '/home/seller/support-ticket',
          meta:{ title: 'Seller | Support Ticket'},
          component: SellerSupportTicket,
          name: 'Seller | Support Ticket'
        },
        {
          path: '/home/seller/settings',
          meta:{ title: 'Seller | Settings'},
          component: SellerSettings,
          name: 'Seller | Settings'
        },
        // {
        //   path: '/student/view-video/:course_id/:course_name/:module/:unit/:video_name/:video_id',
        //   meta:{ title: 'Course Contents'},
        //   component: StudentViewVideo
        //   name: 'View Profile'
        // },
        // Misc Routes
        {
            path:'/EmptyCanvas', 
            component:ExampleComponent
        },
        {
            path:'*',
            component:NotFound
        }

  ]
  
//     }
// ]



// router.beforeEach((to, from, next) => {
//     //  Redirect if not authenticated on secured routes
//     if (to.matched.some(m => m.meta.requiresAuth)) {
//       if (!store.getters['auth/isAuthenticated']) {
//         return next('/login')
//       }
//     }
  
//     if (to.matched.some(m => m.meta.redirectIfAuthenticated) && store.getters['auth/isAuthenticated']) {
//       return next('/admin/dashboard')
//     }
  
//     return next()
//   })

const router = new VueRouter({
    mode: 'history',
    routes, // short for `routes: routes`
    linkActiveClass: 'active'
  });

  export default router;
